<template>
    <v-container>
        <v-row class="contentRow">
            <v-col cols="auto" class="darkColor--text">
                <h1 class="text-left mb-0">Auditor View</h1>
            </v-col>
			<v-col cols="auto">
				<v-btn class="mt-2" dark v-if="$accessToOperation('AR','C')" to="/audit/auditor/new" color="orangeButton">
					<v-icon left small>fas fa-plus</v-icon>
                       Audit Request
                </v-btn>
			</v-col>
            <v-col cols="12" class="flex-grow-0 pt-20">
                <p>
                    This is the overview of audits you have sent. Completed audits have been filled out by the recipient and are awaiting your assessment.
                    <br />Pending audits have not yet been completed by the submitter.
                </p>
            </v-col>
            <v-spacer />

          
			<v-col cols="12">
				<v-tabs background-color="transparent" light icons-and-text>	
					<v-tab>
						Completed
						<v-icon>fas fa-check</v-icon>
					</v-tab>

					<v-tab>
						Pending
						<v-icon>fas fa-hourglass-half</v-icon>
					</v-tab>
					<!-- Searching -->
					
					<v-tab-item>
						<v-row class="mt-3">
							<v-col cols="4" class="pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Template name"
									v-model="templateName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="4" class="pl-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Submitter"
									v-model="senderName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="auto">
								<v-btn v-if="assessment==1" :disabled = "!templateName && !senderName" class="mr-0" elevation="0" medium color="white" @click="clear('a')">Clear</v-btn>
								<v-btn v-else :disabled = "!templateName && !senderName" class="mr-1" medium color="white" elevation="0" @click="clear('c')">Clear</v-btn>
								<v-btn v-if="assessment==1" class="ml-0" medium color="primary" @click="search('a')"><v-icon>fas fa-search</v-icon>Search</v-btn>
								<v-btn v-else class="ml-0" medium color="primary" @click="search('c')"><v-icon>fas fa-search</v-icon>Search</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card background-color="transparent" elevation="0" outlined>
										<v-tabs background-color="transparent" color="orangeButton" v-model="assessment">
											<v-tab key="notAssessed">
												Not assessed
											</v-tab>

											<v-tab key="assessed">
												assessed
											</v-tab>
											<v-tab-item key="notAssessed">
												<v-data-table
													:loading="loading"
													theme--
													light
													:headers="headersCompleted"
													:items="completedaudits"
													:options.sync="completedaudits_options"
													:server-items-length="completedaudits_total"
													:items-per-page="10"
													class="light table"
													:footer-props="{
														'items-per-page-options':[
															5,
															10,
															15
														]
													}"
												>
													<template v-slot:item.assess="{ item }">
														<v-btn
															:to="'/audit/audits/'+item.id"
															color="primary"
															label
															small
															elevation="2"
														>
															<v-icon left small>fas fa-tasks</v-icon>
															{{item.assess}}
															{{$accessToOperation('AU','U') ? "Assess" : "View"}}
														</v-btn>
													</template>
												</v-data-table>
											</v-tab-item>
											<v-tab-item key="assessed">
												<v-data-table
													:loading="loading"
													theme--
													light
													:headers="headersAssessed"
													:items="assessedaudits"
													:options.sync="assessedaudits_options"
													:server-items-length="assessedaudits_total"
													:items-per-page="10"
													class="light table"
													:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
												>
													<template v-slot:item.view="{ item }">
														<v-btn
															:to="'/audit/audits/'+item.id"
															color="primary"
															label
															small
															elevation="2"
														>
															<v-icon left small>far fa-eye</v-icon>
															{{item.view}}
															View
														</v-btn>
													</template>
													<template  v-slot:item.expiryDate="{ item }">
														<p  v-if="$moment(item.expiryDate).isBefore($moment())" style="color: red ;margin-bottom: 0px">{{item.expiryDate | moment("DD/MM/YYYY")}}
															<v-icon color="red" style="margin:5px" >fas fa-times-circle</v-icon>
														</p>
														<p v-else style="margin-bottom: 0px">{{item.expiryDate | moment("DD/MM/YYYY")}}</p>
													</template>
												</v-data-table>
											</v-tab-item>
										</v-tabs>
								</v-card>
							</v-col>
						</v-row>
					</v-tab-item>
					<v-tab-item>
						<v-row class="mt-3">
							<v-col cols="4" class="pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Template"
									v-model="pending_templateName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="4" class="pl-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Submitter"
									v-model="pending_recipientName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="auto">
								<v-btn class="mr-1" medium elevation="0" :disabled="!pending_recipientName && !pending_templateName" color="white" @click="clear('p')">Clear</v-btn>
								<v-btn class="ml-0" medium color="primary" @click="search('p')"><v-icon>fas fa-search</v-icon>Search</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card elevation="0" outlined>
									<v-data-table
										:loading="loading"
										theme--
										light
										:headers="headersPending"
										:items="pendingaudits"
										:server-items-length="pendingaudits_total"
										:options.sync="pendingaudits_options"
										:items-per-page="20"
										class="light table"
										:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
									>
										<template v-slot:item.expiryDate="{ item }">
											<span
												:class= "getColorsForExpiry(item.expiryDate)">
												{{ item.expiryDate }}
											</span>
										</template>
										<template v-slot:item.view="{ item }">
											<v-btn
												@click="showRequestDialog(item)"
												color="primary"
												label
												small
												elevation="2"
											>
												<v-icon left small>far fa-eye</v-icon>
												View
											</v-btn>
										</template>
										<template v-slot:item.remove="{ item }">
											<v-btn small color="#B4B4B4" v-on:click="showDeleteDialog(item)">
												<v-icon small color="white">fas fa-times</v-icon>
											</v-btn>
										</template>
									</v-data-table>
								</v-card>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs>
			</v-col>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>
						Are you sure you want to remove
						<br />this audit request?
					</v-card-title>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
            <v-dialog 
				v-model="dialogRequestView"
				max-width="1200px"
				height="auto"
				scrollable
				align = "center">
				<v-card>
					<v-card-text class="background-color: white" v-if="previewTemplateID!=null">		
						<template-preview
							:previewID="previewTemplateID"
							:preview="false"
							:submitterName="submitterName"
						/>
					</v-card-text>
					<v-card-actions>
						<v-btn 
							color="primary" 
							text 
							@click="dialogRequestView = false; submitterName = null; previewTemplateID=null" 
							outlined
						>Close</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>    
        </v-row>
    </v-container>
</template>

<script>
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
import AuditRequestsAPI from "../../api/audit/request"
import TemplatePreview from "../audit/TemplatePreview.vue"
import InvitationcodeAPI from "../../api/connections/invitationcodes"
//import { mapState } from "vuex";
export default {
	name: "ClientAuditOverview",
	components: {
		"template-preview" : TemplatePreview
	},
	data() {
		return {
			headersCompleted: [
				{
					text: "Submitter",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Time",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
			],

			headersAssessed: [
				{
					text: "Submitter",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Expiry Date",
					value: "expiryDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],
			headersPending: [
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Submitter",
					value: "sender" || "invitationCodeName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Sent Date",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Days until Expiry",
					value: "expiryDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],
			assessment: "notAssessed",
			completedaudits: [],
			completedaudits_options: {
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				sort: null
			},
			completedaudits_total: 0,
			assessedaudits: [],
			assessedaudits_options: {
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				sort: null },
			assessedaudits_total: 0,
			pendingaudits: [],
			pendingaudits_options: {
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				sort: null
			},
			pendingaudits_total: 0,
			loading: false,
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			submitterName: null,
			previewTemplateID: null,
			dialogRequestView: false,
			// For assessed audits - search
			templateName: null,
			senderName: null,
			sort: null,
			// For completed audits - search
			comp_sort: null,
			comp_templateName: null,
			comp_senderName: null,
			pending_templateName: null,
			pending_recipientName: null,
			pending_sort: null
		}
	},
	mounted() {
		// Dummy Data
		this.loadCompletedAudits()
		this.loadAssessedAudits()
		this.loadPendingAudits()
		let hasAccess = this.$accessToOperation("AU","U")
		if (hasAccess) {
			this.headersCompleted.push(
				{
					text: hasAccess ? "Assess" : "View",
					value: "assess",
					sortable: false,
					class: "darkColor--text"
				}
			)
		}

		let hasDeleteAccess = this.$accessToOperation("AR","D")
		
		if (hasDeleteAccess) {
			this.headersPending.push(
				{
					text: "Remove",
					value: "remove",
					sortable: false,
					class: "darkColor--text"
				}
			)
		}
	},

	methods: {
		loadCompletedAudits() {
			let hasAccess = this.$accessToOperation("AU","U")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			this.loading = true
			const { page, itemsPerPage, templateName, senderName, sort } = this.completedaudits_options
			AuditsAPI.list({type: "incoming", status: "0", limit: itemsPerPage, offset: (page-1)*itemsPerPage, flowDown:0,  otherParams:{templateName: templateName, senderName: senderName, sort: sort}})
				.then(result => {
					this.completedaudits = []
					for (let entry of result.items) {
						this.completedaudits.push({
							id: entry.id,
							sender: entry.senderName || entry.sender,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							assess: hasAccess ? null : undefined
						})
					}
					this.completedaudits_total = result.total
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadAssessedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			this.loading = true
			const { page, itemsPerPage, templateName, senderName, sort } = this.assessedaudits_options
			AuditsAPI.list({type: "incoming", notStatus: "0", limit: itemsPerPage, offset: (page-1)*itemsPerPage, flowDown:0, otherParams:{templateName: templateName, senderName: senderName, sort: sort}})
				.then(result => {
					this.assessedaudits = []
					for (let entry of result.items) {
						var statusname = {
							0: "Pending",
							1: "Approved",
							2: "Conditionally Approved",
							3: "Denied"
						}
						var status = statusname[entry.status]
						if(entry.allowFlowDown ==0){
							this.assessedaudits.push({
								id: entry.id,
								sender: entry.senderName || entry.sender,
								timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
								expiryDate: entry.expiryDate,
								template: entry.templateName,
								status: status,
								view: null
							})
						}
					}
					this.assessedaudits_total = result.total
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadPendingAudits() {
			let hasDeleteAccess = this.$accessToOperation("AR","D")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			this.loading = true
			const { page, itemsPerPage, templateName, recipientName, sort } = this.pendingaudits_options
			InvitationcodeAPI.list
			AuditRequestsAPI.list({type: "outgoing", offset: (page-1)*itemsPerPage, limit: itemsPerPage, flowDown:0, otherParams:{templateName: templateName, recipientName: recipientName, sort: sort}})
				.then(result => {
					const currentDate = new Date()
					this.pendingaudits = []
					for (let entry of result.items) {
						const expiryDate = new Date(entry.expirydate)    // Convert expiry date string to Date object
						const timeDifference = expiryDate - currentDate
						let daysToExpiry = Math.round(timeDifference/ (1000 * 60 * 60 * 24))
						if( daysToExpiry <= 0 ){
							daysToExpiry = "Expired"
						}

						this.pendingaudits.push({
							id: entry.requestID,
							sender: entry.recipientName || entry.invitationCodeName,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							expiryDate: daysToExpiry,
							template: entry.templateName,
							templateID: entry.templateID,
							remove: hasDeleteAccess ? null : undefined
						})
					}
					this.pendingaudits_total = result.total
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},

		getColorsForExpiry(expiryDate){
			if(expiryDate === "Expired"){
				return "red--text"
			}else if ( expiryDate <= 14) {
				return "orange--text"
			}
		},

		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},

		showRequestDialog(item) {
			this.submitterName = item.sender || item.invitationCodeName
			this.previewTemplateID = item.templateID
			this.dialogRequestView = true
		},

		removeRow() {
			this.dialogDelete = false
			let index = this.pendingaudits.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditRequestsAPI.deleteRequest(this.itemToDelete.id)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Audit was successfully removed from the list.",
						{ root: true }
					)
					this.pendingaudits.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		search(type) {
			if (type == "a" || type == "c") {
				this.assessedaudits_options.templateName = this.templateName
				this.assessedaudits_options.senderName = this.senderName
				this.assessedaudits_options.sort = this.sort
				
				this.completedaudits_options.templateName = this.templateName
				this.completedaudits_options.senderName = this.senderName
				this.completedaudits_options.sort = this.comp_sort
	
				this.loadAssessedAudits()
			} else if (type == "p") {
				this.pendingaudits_options.templateName = this.pending_templateName
				this.pendingaudits_options.recipientName = this.pending_recipientName
				this.pendingaudits_options.sort = this.pending_sort
				console.log("PENDINGAUDITS")
				console.log(this.pendingaudits_options)
				console.log(this.pending_recipientName)
				

				this.loadPendingAudits()	
			}
		},
		clear(type) {
			if (type == "a" || type == "c") {
				this.assessedaudits_options.templateName = null
				this.assessedaudits_options.senderName = null
				this.assessedaudits_options.sort = null
				this.completedaudits_options.templateName = null
				this.completedaudits_options.senderName = null
				this.completedaudits_options.sort = null
				this.templateName = null
				this.senderName = null
	
				this.loadAssessedAudits()
			} else if (type == "p") {
				this.pendingaudits_options.templateName = null
				this.pendingaudits_options.recipientName = null
				this.pendingaudits_options.sort = null
				this.pending_templateName = null
				this.pending_recipientName = null
				

				this.loadPendingAudits()	
			}
		},
		setSort(type, sort) {
			if (sort != "id_asc" && sort != "id_desc") {
				return
			}

			if (type == "a") {
				if (this.sort == sort) {
					this.sort = null
					return
				}
				this.sort = sort
			} else if (type == "c") {
				if (this.comp_sort == sort) {
					this.comp_sort = null
					return
				}
				this.comp_sort = sort
			}

		}
	}
	,
	watch: {
		completedaudits_options: {
			handler () {
				this.loadCompletedAudits()
			},
			deep: true,
		},
		assessedaudits_options: {
			handler () {
				this.loadAssessedAudits()
			},
			deep: true,
		},
		pendingaudits_options: {
			handler () {
				this.loadPendingAudits()
			},
			deep: true,
		},
	},
}
</script>
<!--<style>
.completed-table thead th {
    font-size: 14px !important;
}
.assessed-table thead th {
    font-size: 14px !important;
}
.pending-table thead th {
    font-size: 14px !important;
}
</style>!-->